import { ICourseEnrollmentItem } from "../components/SelectCourseCard/types"

export const parseAndValidateAddedCourses = (
  value: string | null,
): ICourseEnrollmentItem[] => {
  try {
    if (!value) return []
    const parsed = JSON.parse(value)
    if (!Array.isArray(parsed)) return []

    const validatedCourses = parsed
      .filter(
        (item) =>
          typeof item === 'object' &&
          item !== null &&
          'courseId' in item &&
          (item.courseId !== undefined || item.courseId !== null),
      )
      .map<ICourseEnrollmentItem>((item) => {
        return {
          ...item,
          courseId: item.courseId ?? null,
          tariffId: item.tariffId ?? null,
          value: item.value ?? null,
          withDemo: item.withDemo ?? false,
          enrollDate: item.enrollDate ?? null,
        }
      })

    return validatedCourses
  } catch {
    return []
  }
}
